<template>
  <div id="app">
    <b-container class="main" fluid>
      <v-menu />
      <router-view />
      <!-- <v-footer /> -->
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'

Vue.component('v-menu', Menu)
Vue.component('v-footer', Footer)

export default {
  name: 'App',
  data () {
    return {
      onLine: navigator.onLine
    }
  },
  methods: {
    updateOnlineStatus (e) {
      const { type } = e
      this.onLine = type === 'online'
    }
  },
  watch: {
    async onLine (v) {
      if (v) {
        this.$bvToast.toast('Sei nuovamente connesso ad Internet.', {
          title: 'Sei connesso',
          autoHideDelay: 3750,
          appendToast: false,
          variant: 'success',
          solid: true
        })
      } else {
        this.$bvToast.toast('Controlla la tua connessione ad Internet.', {
          title: 'Nessuna connessione',
          autoHideDelay: 4250,
          appendToast: false,
          variant: 'danger',
          solid: true
        })
      }
    }
  },
  mounted () {
    // handle case when dasboard is not reachable
    this.$nextTick(function () {
      const { localStorage, top, self } = window
      if (top === self && localStorage.getItem('from-iframe') === 'true') {
        localStorage.setItem('from-iframe', false)

        this.$bvToast.toast('La dashboard selezionata non è al momento accessibile.', {
          title: 'Dashboard non accessibile',
          autoHideDelay: 3750,
          appendToast: false,
          variant: 'warning',
          solid: true
        })
      }
    })

    // add listeners for checking connection state
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  },
  beforeDestroy () {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600&display=swap');

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
  height: 100vh;
}

.main {
  margin: 0;
  padding: 0;
}

.fa-icon {
  top: 0.125em;
  position: relative;
}

.b-main-content {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  margin-right: 0;
  margin-left: 0;
}

.done-icon {
  width: 1.4rem;
  height: 1.4rem;
  color: white;
}

.done-icon.green {
  color: #28a745;
}

.info-icon {
  width: 1.4rem;
  height: 1.4rem;
}

.basic-box-shadow {
  border: 0.1rem solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.03);
}

.b-form-1 {
  padding: 1.5rem;
  margin-right: 0;
  margin-left: 0;
  border-radius: 0.3rem;
  background: #fefefe;
}
</style>
